module.exports = __webpack_public_path__ + "img/chargingpoint-alert.9205daf5.png";